module.exports = __webpack_public_path__ + "img/weixin.cf7b9370.png";